import { Box, Container } from '@mui/material'
import { useCallback, useState } from 'react'
import { APP_VERSION } from 'src/utils/Constants'
import Text from '../Text'

export interface IFooter {
  isAuthScreen: boolean
}

const Footer = (_: IFooter) => {
  const [count, setCount] = useState(0)

  const onClick = useCallback(() => {
    setCount((prev) => prev + 1)
    if (count === 10) alert(APP_VERSION)
  }, [count])

  return (
    <Container>
      <Box mt={30} mb={1}>
        <Text color="white" size={12} align="center" onClick={onClick}>
          Copyright&copy;&nbsp;2026&nbsp;STNet,&nbsp;Inc&nbsp;All&nbsp;Right&nbsp;Reserved.
        </Text>
      </Box>
    </Container>
  )
}

export default Footer
